module.exports = __webpack_public_path__ + "img/MonstersGuidetoJoy-Cover-1280.df6e8354.png";